

// $Classes/Enums/Interfaces(filter)[template][separator]
// filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
// template: The template to repeat for each matched item
// separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

// More info: http://frhagn.github.io/Typewriter/


export class Profile {
    
    public id: number = 0;
    public name: string = null;
    public isUnique: boolean = false;
    public profileTab: boolean = false;
    public areaTab: boolean = false;
    public userTab: boolean = false;
    public importExport: boolean = false;
    public printReports: boolean = false;
    public createEditProject: boolean = false;
    public createCustomDatasheet: boolean = false;
    public description: string = null;
    public viewAreas: boolean = false;
    public viewUsers: boolean = false;
    public editSites: boolean = false;
}

